import { getOtherLoginUrl, logger } from '@/utils';
import { autobind, Injectable } from '@kaokei/use-vue-service';
import { DaoService } from '../dao.service';
import { DeviceManager } from '@/utils';
import { DeviceErrorDescription } from '@/utils/device/error';
import { IError } from '@/utils/device/interface';
import { checkBrowser } from '@/utils/check';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { CosService } from '../cosmaz.service';
import { UserService } from '../user.service';
import { getMediaConfig } from '@/utils/device/mediaConfig';
// import { cloneDeep } from 'lodash-es';

const delayFn = (time = 2) => {
  // 每次检测至少10s以上，否则显得不够真实
  return new Promise(resolve => {
    window.setTimeout(() => resolve(true), time * 1000);
  });
};

export type StatusType = 'wait' | 'process' | 'finish' | 'error';

export type DeviceItemType = {
  status: StatusType;
  txt: string;
  deviceList: MediaDeviceInfo[];
};

export type DeviceStateType = {
  showVideo: boolean;
  hasClickChecked: boolean;
  browser: DeviceItemType;
  camera: DeviceItemType;
  micro: DeviceItemType;
};

export type StepItemtype = {
  label: string;
  status: StatusType;
  resultStatus: StatusType;
  comName: string;
  // 0 标识检测设备 1 标识验证身份 2 标识等待考试
  stepType: 0 | 1 | 2;
  // 记录是否是错误状态
  recordError: boolean;
};

// const StatusMap = ['检测未通过', '检测通过', '跳过检测', '未检测'];

enum CheckStatusEnum {
  FAIL = 0, // 检测未通过
  PASS = 1, // 检测通过
  SKIP = 2, // 跳过检测
  NO_CHECK = 3, // 未检测
}
@Injectable()
export class CheckerService {
  route: any = useRoute();
  router: any = useRouter();
  public pageInitLoading = false;
  public userExamId = 0;
  public contestInfoId = 0;
  public stream?: MediaStream; // 视频流和音频流
  public error?: Event; // 错误信息
  // 设备检测状态 active | inactive
  public deviceActiveStatus = '';

  // 检测步骤
  public checkStep: StepItemtype[] = [
    {
      label: '设备检测',
      status: 'process',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-one',
      stepType: 0,
    },
    {
      label: '身份验证',
      status: 'wait',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-two',
      stepType: 1,
    },
    {
      label: '开始考试',
      status: 'wait',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-three',
      stepType: 2,
    },
  ];

  // public constraints = {
  //   audio: true,
  //   video: {
  //     width: { min: 640, ideal: 640, max: 640 },
  //     height: { min: 480, ideal: 480, max: 480 },
  //     framerate: 60,
  //   },
  // };
  public get constraints() {
    const mediaConfig = getMediaConfig();
    return mediaConfig;
  }

  public combinationResult: any = null;
  // 初始化获取检测结果
  public InitCheckResult = {
    device: CheckStatusEnum.NO_CHECK,
    face: CheckStatusEnum.NO_CHECK,
  };

  // 检测浏览器的结果
  public checkBrowserResult: any;
  // 检测ID
  public checkId = 0;

  public currentStepIndex = 0;

  // 身份校验图片url
  public photoDataUrl = '';
  // 考试开始时间
  public startExamTimestamp = 0;
  // getRemainTime时返回的服务器时间
  public serverRemainTime = 0;
  // 每隔1秒的倒计时定时器
  public countdownTimer = 0;
  // 本地时间
  public localTime = 0;
  // 获取serverRemainTime的本地时间
  public localGetRemainTime = 0;
  // 本地时间间隔
  public localTimeGap = 0;
  // 倒计时信息
  public countDownTimeData = {
    h: '--',
    min: '--',
    sec: '--',
  };
  // 是否已经开始考试
  public isCanEntrance = false;

  public deviceManager?: any;

  public DeviceState: DeviceStateType = {
    showVideo: false,
    hasClickChecked: false,
    browser: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
    camera: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
    micro: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
  };

  public NoDeviceVisible = false;
  public NeedAutoCheckDevice = false;

  // 配置的身份检测示例地址
  public faceCheckStandardUrl = '';

  public examDetail: any = {};
  // 是否已经请求获取考试明细信息标识
  public examDetailGeted = false;

  constructor(
    public daoService: DaoService,
    public cosService: CosService,
    public userService: UserService
  ) {
    this.deviceManager = new DeviceManager();
  }

  @autobind
  public initPage() {
    try {
      const { qs } = this.route.query;
      const { id, contestId } = JSON.parse(window.atob(qs));
      this.userExamId = id;
      this.contestInfoId = contestId;
    } catch (e) {
      message.error('参数解析异常，请确保从正确的入口处进入');
    }
    this.getCombinationResult();
  }

  @autobind
  public goStep(index: number, judgeStep = false) {
    const prevStepIndex = this.currentStepIndex;
    if (judgeStep) {
      // 需要校验一下能否进行下一步
      if ([0, 3].includes(this.InitCheckResult.device)) {
        if (prevStepIndex < index) return;
      }
      // 得过滤掉不需要身份验证的情况
      if (
        [0, 3].includes(this.InitCheckResult.face) &&
        this.combinationResult.faceCheckConfigStatus
      ) {
        if (prevStepIndex < index) return;
      }
      // 如果第2步存在异常
      if (
        this.InitCheckResult.device === CheckStatusEnum.PASS &&
        this.InitCheckResult.face === CheckStatusEnum.SKIP &&
        this.combinationResult.faceCheckConfigStatus
      ) {
        if (prevStepIndex < index) return;
      }
    }
    this.currentStepIndex = index;
    for (let i = 0; i < this.checkStep.length; i++) {
      const itemStep = this.checkStep[i];
      if (i < index) {
        const { resultStatus, status } = itemStep;
        this.checkStep[i] = {
          ...itemStep,
          status: ['error'].includes(status)
            ? 'error'
            : ['error'].includes(resultStatus)
            ? 'error'
            : 'finish',
        };
      } else if (i === index) {
        this.checkStep[i] = {
          ...itemStep,
          status: 'process',
        };
      } else {
        this.checkStep[i] = {
          ...itemStep,
          status: 'wait',
        };
      }
    }
  }

  @autobind
  public getMediaStream() {
    this.reset();
    const { DeviceState } = this;
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then(mstream => {
          this.stream = mstream;

          mstream.getTracks().forEach(track => {
            if (track.kind == 'audio') {
              track.onended = event => {
                this.error = event;
                this.dispose();
              };
            }
            if (track.kind == 'video') {
              track.onended = event => {
                this.error = event;
                this.dispose();
              };
            }
          });

          this.deviceActiveStatus = 'active';
          this.stream.addEventListener('inactive', this.msInactiveHandler);
          window.hetaoTrack('element_show', {
            elementName: '赛考赛前检测状态',
            statusText: 'success',
            live_status: 'success',
            userId: this.userService?.user?.userId || 0,
            uniqueId: this.userExamId,
          });
          resolve(mstream);
        })
        .catch(e => {
          if (e instanceof Error) {
            const errResult = this.parseErrorMsg(e);
            if (errResult) {
              DeviceState.camera.txt = errResult.message;
              DeviceState.camera.status = 'error';
              DeviceState.micro.txt = errResult.message;
              DeviceState.micro.status = 'error';
            }
          }
          window.hetaoTrack('element_show', {
            elementName: '赛考赛前检测状态',
            statusText: e?.message || 'error',
            live_status: 'error',
            userId: this.userService?.user?.userId || 0,
            uniqueId: this.userExamId,
          });
          resolve(null);
        });
    });
  }

  @autobind
  public msInactiveHandler() {
    this.deviceActiveStatus = 'inactive';
    window.hetaoTrack('element_show', {
      elementName: '赛考赛前检测状态',
      statusText: 'inactive',
      live_status: 'inactive',
      userId: this.userService?.user?.userId || 0,
      uniqueId: this.userExamId,
    });
  }

  @autobind
  public reset() {
    if (this.stream) {
      this.stream.removeEventListener('inactive', this.msInactiveHandler);
    }
    this.deviceActiveStatus = '';
    this.stream = undefined;
    this.error = undefined;
  }

  @autobind
  public dispose() {
    logger.warn('warn media service dispose => 1', new Date().toLocaleString());
    if (this.stream) {
      logger.warn(
        'warn media service dispose => 2',
        new Date().toLocaleString()
      );
      try {
        logger.warn(
          'warn media service dispose => 3',
          new Date().toLocaleString()
        );
        this.stream.getTracks().forEach(track => track.stop());
        logger.warn(
          'warn media service dispose => 4',
          new Date().toLocaleString()
        );
      } catch (e) {
        logger.warn(
          'warn media service dispose => 5',
          new Date().toLocaleString()
        );
        // add sentry mark
        // console.log('setTag', 'dispose mediaService');
        logger.debug('dispose中停止音视频异常 => ', e);
      }
    }
    this.stream = undefined;
    this.deviceActiveStatus = '';
  }

  @autobind
  public parseErrorMsg(err: Error) {
    if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICEDISMISSED ||
      err.name === DeviceErrorDescription.ERRORMESSAGE_DEVICEDISMISSED
    ) {
      return {
        message: '权限未被允许或被驳回',
        otherMsg: '关闭了权限弹窗',
      };
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTFOUND ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTFOUND
    ) {
      return {
        message: '未找到相关设备',
        otherMsg: '',
      };
      // return new DeviceError(
      //   DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTFOUND,
      //   'video device not found'
      // );
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MOBILEDEVICE_NOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACSAFARI_DEVICENOTALLOWED
    ) {
      return {
        message: '不允许使用相关设备',
        otherMsg: '权限允许弹窗被拒绝，或被拒绝过',
      };
      // return new DeviceError(
      //   DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTALLOWED,
      //   'video device not allowed'
      // );
    } else if (
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACCHROME_DEVICENOTREADABLE ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_VIDEODEVICENOTREADABLE ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTREADABLE
    ) {
      return {
        message: '没有使用相关设备权限',
        otherMsg:
          '设备硬件错误，或浏览器被系统禁止权限，如Mac-安全性与隐私-隐私-麦克风',
      };
      // return new DeviceError(
      //   DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTREADABLE,
      //   'video device not readable'
      // );
    } else if (
      err.name === DeviceErrorDescription.ERRORNAME_DEVICEOVERCONSTRAINED
    ) {
      return {
        message: '无法满足当前MediaStreamTrack的所需功能集',
        otherMsg: '',
      };
      // return new DeviceError(
      //   ErrorCode.ERROR_DEIVCE_CONSTRAINEDERROR,
      //   'constraints' + err.constraint + ' error'
      // );
    }
    return null;
  }

  @autobind
  public getDeviceList(): Promise<Array<MediaDeviceInfo>> {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(deviceList => {
          const arr: Array<MediaDeviceInfo> = [];
          deviceList.forEach((device: MediaDeviceInfo) => {
            arr.push(device);
          });
          resolve(arr);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  @autobind
  public getChromeVersion() {
    const userAgent = navigator.userAgent;
    const chromeVersionMatch = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    if (chromeVersionMatch) {
      return {
        status: 200,
        version: `Chrome内核版本：${chromeVersionMatch[1]}`,
      };
    } else {
      return {
        status: 0,
        version: '非Chrom内核浏览器',
      };
    }
  }

  @autobind
  public async checkBrowser() {
    const { DeviceState } = this;
    await delayFn(1);
    const result = this.getChromeVersion();
    DeviceState.browser.status = result.status === 200 ? 'finish' : 'error';
    DeviceState.browser.txt = result.version;
  }
  public async checkVideo() {
    const { DeviceState } = this;
    DeviceState.camera.status = 'process';
    await delayFn(1);
    return new Promise((resovle, reject) => {
      this.deviceManager
        .getCameraList()
        .then((list: any) => {
          DeviceState.camera.status = 'finish';
          DeviceState.camera.deviceList = list;
          DeviceState.camera.txt = list[0].label;
          this.canCheckTotal();
          resovle(true);
        })
        .catch((e: IError) => {
          DeviceState.camera.txt = e.reason || '~未找到设备~';
          DeviceState.camera.status = 'error';
          reject(e);
        });
    });
  }

  @autobind
  public async checkAudio() {
    const { DeviceState } = this;
    DeviceState.micro.status = 'process';
    await delayFn(1);
    return new Promise((resovle, reject) => {
      this.deviceManager
        .getMicList()
        .then((list: any) => {
          DeviceState.micro.deviceList = list;
          DeviceState.micro.status = 'finish';
          DeviceState.micro.txt = list[0].label;
          this.canCheckTotal();
          resovle(true);
        })
        .catch((e: IError) => {
          DeviceState.micro.txt = e.reason || '~未找到设备~';
          DeviceState.micro.status = 'error';
          reject(e);
        });
    });
  }

  @autobind
  public async canCheckTotal() {
    const { DeviceState } = this;
    if (
      DeviceState.camera.status === 'finish' &&
      DeviceState.micro.status === 'finish'
    ) {
      try {
        await this.getMediaStream();
        DeviceState.camera.status = 'finish';
        DeviceState.micro.status = 'finish';
        DeviceState.showVideo = true;
        // // 更新检测记录
        // await this.updateCheckRecord();
      } catch (e) {
        if (e instanceof Error) {
          const errResult = this.parseErrorMsg(e);
          if (errResult) {
            DeviceState.camera.txt = errResult.message;
            DeviceState.camera.status = 'error';
            DeviceState.micro.txt = errResult.message;
            DeviceState.micro.status = 'error';
          }
        }
      }
    }
  }

  @autobind
  // 其他需要检测的明细
  public getCheckBrowserResult() {
    const result = checkBrowser();
    this.checkBrowserResult = result;
    return result;
  }

  /**
   * 正常环境检测结束的后续处理方法
   * 对应的是检测超时处理方法
   *
   * @param {*} result
   * @return {*}
   */
  @autobind
  public normalFinishCheck() {
    if (!this.checkId) return; // 如果checkId不存在，则后续不处理了
    this.updateCheckRecord();
    this.dispose();
  }

  /**
   * 开始环境检测，从服务器端获取检测ID
   *
   * @return {*}
   * @memberof EnvCheckService
   */
  @autobind
  public getStartCheckId() {
    return this.daoService.addCheckRecord(this.userExamId).then(res => {
      this.checkId = res;
    });
  }

  /**
   * 检测完成，需要保存检测结果
   *
   * @return {*}
   */
  @autobind
  public async updateCheckRecord(isSkipFlag = false) {
    const { DeviceState } = this;
    const MicroStatusOk = DeviceState.micro.status === 'finish';
    const CameraStatusOk = DeviceState.camera.status === 'finish';
    const DeviceCheckStatus = MicroStatusOk && CameraStatusOk ? 1 : 0;
    let result: any = {};
    // 是否跳过检测
    if (isSkipFlag) {
      result = {
        id: this.checkId,
        result: CheckStatusEnum.SKIP,
        checkItems: {
          userAgent: navigator.userAgent,
          checkVideoAndAudioState: 0,
          checkDeviceData: {
            videoName: '',
            audioName: '',
          },
          ...(this.checkBrowserResult || {}),
        },
        userExamId: this.userExamId,
      };
    } else {
      result = {
        id: this.checkId,
        result: DeviceCheckStatus,
        checkItems: {
          userAgent: navigator.userAgent,
          checkVideoAndAudioState: MicroStatusOk && CameraStatusOk ? 1 : 0, // 1代表检测成功，0代表失败
          checkDeviceData: {
            videoName: DeviceState.camera.txt || '',
            audioName: DeviceState.micro.txt || '',
          },
          ...(this.checkBrowserResult || {}),
        },
        userExamId: this.userExamId,
      };
    }
    const res = await this.daoService.updateCheckRecord(result);
    this.InitCheckResult.device = result.result;
    const deviceStep = this.checkStep[0];
    if (isSkipFlag || !DeviceCheckStatus) {
      deviceStep.status = 'error';
      deviceStep.resultStatus = 'error';
      deviceStep.recordError = true;
    } else {
      deviceStep.status = 'finish';
      deviceStep.resultStatus = 'wait';
      deviceStep.recordError = false;
    }
    return res;
  }

  /**
   * 获取检测结果
   */
  @autobind
  public async getCombinationResult() {
    this.pageInitLoading = true;
    try {
      const res: any = await this.daoService.getCombinationResult({
        userExamId: this.userExamId,
        contestInfoId: this.contestInfoId,
      });
      this.faceCheckStandardUrl = res?.faceCheckStandardUrl;
      this.checkId = res?.checkRecordInfo?.id ?? 0;
      this.photoDataUrl =
        res?.faceRecordInfo?.result === 2
          ? ''
          : res?.faceRecordInfo?.signatureUrl ?? '';
      // 判断是否添加了身份验证
      const hasFaceCheck = res?.faceCheckConfigStatus === 1;
      this.combinationResult = {
        ...res,
        needCheckFace: hasFaceCheck,
      };
      this.InitCheckResult = {
        device: res?.checkRecordInfo?.result ?? CheckStatusEnum.NO_CHECK,
        face: res?.faceRecordInfo?.result ?? CheckStatusEnum.NO_CHECK,
      };
      // 不存在身份校验 就删除第二部
      if (!hasFaceCheck) {
        this.checkStep.splice(1, 1);
      }
      // 判断是否检测过了设备 浏览器
      if (res?.checkRecordInfo?.result === CheckStatusEnum.PASS) {
        this.currentStepIndex = 1;
        this.goStep(1);
      }
      if (
        hasFaceCheck &&
        res?.faceRecordInfo?.result === CheckStatusEnum.PASS
      ) {
        this.currentStepIndex = 2;
        this.goStep(2);
      }
      // 跳过了检测
      if (res?.checkRecordInfo?.result === CheckStatusEnum.SKIP) {
        if (this.route.meta.platform) {
          this.goStep(0);
        } else {
          this.goStep(this.checkStep.length - 1);
          this.checkStep.forEach((el: StepItemtype) => {
            if (el.stepType < 2) {
              el.status = 'error';
              el.resultStatus = 'error';
              el.recordError = true;
            } else {
              el.resultStatus = 'wait';
            }
          });
        }
      }
      if (
        hasFaceCheck &&
        res?.faceRecordInfo?.result === CheckStatusEnum.SKIP &&
        res?.checkRecordInfo?.result === CheckStatusEnum.PASS
      ) {
        this.goStep(1);
        // this.checkStep.forEach((el: StepItemtype) => {
        //   if (el.stepType === 1) {
        //     el.status = 'error';
        //     el.resultStatus = 'error';
        //     el.recordError = true;
        //   } else {
        //     el.resultStatus = 'wait';
        //   }
        // });
      }
      if (this.currentStepIndex === 0) {
        this.NeedAutoCheckDevice = true;
      } else {
        this.NeedAutoCheckDevice = false;
      }
      this.pageInitLoading = false;
    } catch (e: any) {
      this.pageInitLoading = false;
      if (e?.errCode === 10000) {
        this.router.push({
          name: this.route.meta.entryUrlName || 'UserItemList',
        });
      }
    }
  }

  /**
   * 开始检测设备
   * @returns
   */
  @autobind
  public checkStartDevice() {
    return new Promise((resolve, reject) => {
      const { DeviceState } = this;
      DeviceState.browser.status = 'process';
      DeviceState.micro.status = 'process';
      DeviceState.camera.status = 'process';
      const asyncCheckStart = async () => {
        try {
          await Promise.all([
            this.checkBrowser(),
            this.getMediaStream(), // catch 异常
            this.getCheckBrowserResult(), // 一定成功
            delayFn(1),
          ]);
          const list = await this.getDeviceList();
          DeviceState.micro.deviceList = [];
          DeviceState.camera.deviceList = [];
          list.forEach((el: MediaDeviceInfo) => {
            if (el.kind === 'audioinput') {
              DeviceState.micro.deviceList.push(el);
            }
            if (el.kind === 'videoinput') {
              DeviceState.camera.deviceList.push(el);
            }
          });
          if (this.stream) {
            if (DeviceState.micro.status !== 'error') {
              DeviceState.micro.status = 'finish';
              DeviceState.micro.txt = DeviceState.micro.deviceList[0]?.label;
            }
            if (DeviceState.camera.status !== 'error') {
              DeviceState.camera.status = 'finish';
              DeviceState.camera.txt = DeviceState.camera.deviceList[0]?.label;
            }
          } else {
            DeviceState.micro.status = 'error';
            DeviceState.micro.txt ||= '未知异常';
            DeviceState.camera.status = 'error';
            DeviceState.camera.txt ||= '未知异常';
          }
          DeviceState.showVideo = true;
          // 状态置为已点击检测
          DeviceState.hasClickChecked = true;
          resolve(true);
        } catch (e: any) {
          // 状态置为已点击检测
          DeviceState.hasClickChecked = true;
          reject(e);
        }
      };
      asyncCheckStart();
    });
  }

  @autobind
  public uploadFaceUrl(blobData: Blob) {
    const fileName = this.cosService.getBlobName(
      'face-identity',
      `${this.userService?.user?.userId}_pic.png`
    );
    return this.cosService.uploadBlob({
      blob: blobData,
      fileName,
      cosType: 'face',
    });
  }

  /**
   * 更新身份验证结果
   * @param url
   * @param result
   * @returns
   */
  @autobind
  public async updateFaceCheckResult(url: string, result = 1) {
    const res = await this.daoService.updateFaceCheckResult({
      imgUrl: url,
      result,
      userExamId: this.userExamId,
      userId: this.userService?.user?.userId,
    });
    this.InitCheckResult.face = result;
    const faceStep = this.checkStep[1];
    if (result === 0) {
      faceStep.status = 'error';
      faceStep.resultStatus = 'error';
      faceStep.recordError = true;
    } else {
      faceStep.status = 'finish';
      faceStep.resultStatus = 'wait';
      faceStep.recordError = false;
    }
    return res;
  }

  @autobind
  public upldateDeviceStatus(status = 'finish' as StatusType) {
    const { DeviceState } = this;
    if (DeviceState.micro.status !== 'error') {
      DeviceState.micro.status = status;
    }
    if (DeviceState.camera.status !== 'error') {
      DeviceState.camera.status = status;
    }
  }

  @autobind
  public getExamDuration() {
    this.examDetailGeted = false;
    this.daoService
      .getExamSummary({
        userExamId: this.userExamId,
      })
      .then((res: any) => {
        this.examDetail = res;
        this.startExamTimestamp = res.startTimestamp;
        this.serverRemainTime = res.currentTimestamp;
        this.isCanEntrance = this.startExamTimestamp <= this.serverRemainTime;
        this.localGetRemainTime = Date.now();
        if (this.isCanEntrance) {
          this.uninstallCountDown();
        } else {
          this.countDownTimeData = this.formatCountDownTime(
            this.serverRemainTime,
            this.startExamTimestamp
          );
          this.setCountdownTimer();
        }
      })
      .catch((e: any) => {
        this.isCanEntrance = false;
        this.uninstallCountDown();
        if ([5010, 5014].includes(e?.errCode)) {
          const otherLoginUrl = getOtherLoginUrl() || '';
          if (otherLoginUrl) {
            setTimeout(() => {
              window.location.replace(otherLoginUrl);
            }, 2000);
          } else {
            this.router.push({
              name: 'UserItemList',
            });
          }
        }
      })
      .finally(() => {
        this.examDetailGeted = true;
      });
  }

  @autobind
  public countDownFn() {
    this.localTime = Date.now();
    this.localTimeGap = this.localTime - this.localGetRemainTime;
    const fakeServerTime = this.localTimeGap + this.serverRemainTime;
    if (fakeServerTime < this.startExamTimestamp) {
      this.countDownTimeData = this.formatCountDownTime(
        fakeServerTime,
        this.startExamTimestamp
      );
      this.setCountdownTimer();
    } else {
      this.isCanEntrance = true;
      this.uninstallCountDown();
    }
  }

  @autobind
  public formatCountDownTime(startTime: number, endTime: number) {
    if (startTime > endTime) {
      return {
        h: '00',
        min: '00',
        sec: '00',
      };
    }
    const timeGap = endTime - startTime;
    const hours = Math.floor(timeGap / (1000 * 60 * 60));
    const minutes = Math.floor((timeGap % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeGap % (1000 * 60)) / 1000);
    const padZero = (num: number) => num.toString().padStart(2, '0');

    return {
      h: padZero(hours),
      min: padZero(minutes),
      sec: padZero(seconds),
    };
  }

  /**
   * 设置倒计时的定时器
   *
   * @memberof CountdownService
   */
  @autobind
  public setCountdownTimer() {
    window.clearTimeout(this.countdownTimer);
    this.countdownTimer = window.setTimeout(this.countDownFn, 1000);
  }

  @autobind
  public uninstallCountDown() {
    window.clearTimeout(this.countdownTimer);
  }

  @autobind
  public uninstall() {
    this.dispose();
    this.uninstallCountDown();
  }

  @autobind
  public handleIgnoreCheckStep() {
    this.getCheckBrowserResult();
    const SkipFlag = true;
    const PromiseArr: any[] = [this.updateCheckRecord(SkipFlag)];
    const lastStepIndex = this.checkStep.length;
    if (this.combinationResult?.faceCheckConfigStatus === 1) {
      PromiseArr.push(this.updateFaceCheckResult('', CheckStatusEnum.SKIP));
    }
    Promise.all([...PromiseArr]).then(() => {
      this.goStep(lastStepIndex - 1);
      this.NoDeviceVisible = false;
      this.checkStep.forEach((el: StepItemtype) => {
        if (el.stepType < 2) {
          el.status = 'error';
          el.resultStatus = 'error';
          el.recordError = true;
        }
      });
    });
  }
}
